import { Outlet } from 'react-router-dom';
import './Reports.scss';

/**
 * @description Reports component that serves as a container for report-related content.
 * This component uses React Router's Outlet to render nested route components for various reports.
 *
 * @SADtrace SAD-003-5
 *
 * @History
 * 04-18-2025 aleksandar dukleski: DLA-1364 added function headers
 * 11-05-2025 aleksandar dukleski: DLA-1428 added history tag to function headers
 *
 * @returns {JSX.Element} A div container with the Outlet for nested routes
 */
const Reports = () => {
  return (
    <div className="d-flex">
      <div className="reports__content">
        <Outlet />
      </div>
    </div>
  );
};

export default Reports;
